import React from "react";
import DesignSitesList from "./design_sites";

// Container for Designing — Project Sites: every Designing site of the projects
// the user is assigned to (role level 1 sees all). Permission-gated by
// DesignSite.view_all in the router.
const DesignSitesPage: React.FC = () => {
  return <DesignSitesList scope="all" title="Designing — Project Sites" />;
};

export default DesignSitesPage;
